 
const TermsAndConditions = () => {
  return (
    <div className="min-h-screen bg-white py-10 px-6 md:px-24 text-gray-700">
      <h1 className="text-2xl md:text-4xl font-bold mb-6 text-blue-600">
        Terms & Conditions
      </h1>

      <p className="mb-4">
        Welcome to <strong>TGM Nursing Institute</strong>. By using our website or enrolling in our courses, you agree to comply with the following terms and conditions.
      </p>

      <h2 className="text-xs font-semibold mt-6 mb-2 text-purple-600">1. Admissions</h2>
      <p className="mb-4 text-xs">
        Admission to our courses is subject to eligibility criteria, availability, and timely payment of fees. Submission of false or misleading information may result in cancellation.
      </p>

      <h2 className="text-xs font-semibold mt-6 mb-2 text-purple-600">2. Fees & Payment</h2>
      <p className="mb-4 text-xs">
        All fees must be paid according to the schedule provided. Late payments may attract penalties, and courses may not be accessible until fees are cleared.
      </p>

      <h2 className="text-xs font-semibold mt-6 mb-2 text-purple-600">3. Refund Policy</h2>
      <p className="mb-4 text-xs">
        Fees paid are non-refundable unless explicitly agreed upon in writing by the administration. Specific refund conditions apply in case of withdrawal.
      </p>

      <h2 className="text-xs font-semibold mt-6 mb-2 text-purple-600">4. Intellectual Property</h2>
      <p className="mb-4 text-xs">
        All course content, logos, images, and materials are the property of TGM Nursing Institute. Unauthorized use, copying, or distribution is prohibited.
      </p>

      <h2 className="text-xs font-semibold mt-6 mb-2 text-purple-600">5. Website Use</h2>
      <p className="mb-4 text-xs">
        You agree to use our website responsibly and not engage in any harmful activities, hacking, or misuse of information.
      </p>

      <h2 className="text-xs font-semibold mt-6 mb-2 text-purple-600">6. Limitation of Liability</h2>
      <p className="mb-4 text-xs">
        TGM Nursing Institute shall not be liable for any indirect, incidental, or consequential damages arising from the use of our website or courses.
      </p>

      <h2 className="text-xs font-semibold mt-6 mb-2 text-purple-600">7. Changes to Terms</h2>
      <p className="mb-4 text-xs">
        We may update these Terms & Conditions periodically. Continued use of our services constitutes acceptance of the revised terms.
      </p>

      <p className="mt-6 text-gray-600">
        Contact: <strong>tgmnursing2019@gmail.com</strong> for any inquiries regarding these Terms.
      </p>

      <p className="mt-4 text-gray-600">
        © 2026 TGM Nursing Institute. All rights reserved.
      </p>
    </div>
  );
};

export default TermsAndConditions;